import { useMemo, useState } from "react";
import { api, fmtBRL } from "@/lib/api";
import { toast } from "sonner";
import { trocoSaidaPendente, somaTroco } from "./MobileTrocoSaida";

// Iter 119: troco de saída pendente (em rota, com troco, sem confirmação) — banner + dialog rápido.
export function useTrocoSaida({ items, setItems, load }) {
  const pendentes = useMemo(() => items.filter((x) => x.status === "em_transito" && trocoSaidaPendente(x)), [items]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const openDialogSoon = (ms) => setTimeout(() => setDialogOpen(true), ms);

  const confirmar = async () => {
    const ids = pendentes.map((x) => x.id);
    if (!ids.length) return setDialogOpen(false);
    setSaving(true);
    try {
      const r = await api.post("/minhas-entregas/confirmar-troco-saida", { entrega_ids: ids });
      const okIds = new Set(r.data?.ids || ids);
      const at = new Date().toISOString();
      setItems((arr) => arr.map((x) => (okIds.has(x.id) ? { ...x, troco_saida_confirmado: true, troco_saida_confirmado_at: at } : x)));
      toast.success(`Troco de ${fmtBRL(r.data?.total ?? somaTroco(pendentes))} confirmado (${r.data?.count ?? ids.length} pedido(s))`);
      setDialogOpen(false);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao confirmar troco");
    } finally { setSaving(false); }
  };

  return { pendentes, dialogOpen, setDialogOpen, openDialogSoon, saving, confirmar };
}
